const collapsables = document.querySelectorAll(".new-menu-drawer__collapsable");

collapsables.forEach((collapsable) => {
    var collapsableSvg = collapsable.querySelector("svg");
    collapsable.addEventListener("click", () => {
        collapsables.forEach((item) => {
            if (item !== collapsable) {
                var openContent = item.querySelector(".collapsable-content");
                var itemSvg = item.querySelector("svg");
                if (openContent.classList.contains("collapsable-content__active")) {
                    openContent.style.height = 0;
                    openContent.style.paddingBlock = 0;
                    openContent.classList.remove("collapsable-content__active");
                    itemSvg.style.transform = "rotate(0deg)";
                }
            }
        });

        var collapsableContent = collapsable.querySelector(".collapsable-content");
        var collapsableContentHeight = collapsableContent.scrollHeight;

        if (collapsableContent.classList.contains("collapsable-content__active")) {
            collapsableContent.style.height = 0;
            collapsableContent.style.paddingBlock = 0;
            collapsableContent.classList.remove("collapsable-content__active");
            collapsableSvg.style.transform = "rotate(0deg)";
        } else {
            collapsableContent.style.height = collapsableContentHeight + "px";
            collapsableContent.classList.add("collapsable-content__active");
            collapsableSvg.style.transform = "rotate(180deg)";
        }
    });
});